import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/placeholder.jpg")